/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { matrixDependencies } from './dependenciesMatrix.generated';
import { NodeDependencies } from './dependenciesNode.generated';
import { subsetDependencies } from './dependenciesSubset.generated';
import { createAssignmentNode } from '../../factoriesAny.js';
export var AssignmentNodeDependencies = {
  matrixDependencies: matrixDependencies,
  NodeDependencies: NodeDependencies,
  subsetDependencies: subsetDependencies,
  createAssignmentNode: createAssignmentNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesAssignmentNode.generated.js
// module id = 617
// module chunks = 0